import { AxiosError } from "axios";

import { LogOperation } from "../../utils/entities/logOperation";
import api from "../api";
import { IPaginatedParams } from "../interface";
import { returnResponse } from "../utils";

export interface TipoParticipanteData {
  active: boolean;
  customerId: number;
  id: number;
  name: string;
  description?: string;
  type: number;
  confidentialityLevel?: number;
}

export interface TipoParticipantePaginatedData {
  items: TipoParticipanteData[];
  totalCount: number;
}

export interface TipoParticipanteResponse {
  data: TipoParticipantePaginatedData;
  errors: string[];
  message: string;
  ok: boolean;
}

export const ParticipantesService = {
  getAllPaginated: async (params: IPaginatedParams) => {
    try {
      const { pageNumber, pageSize, searchTerm, active } = params;
      const queryParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });
      if (active !== undefined && active !== 2) {
        queryParams.append("active", String(active));
      }
      if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
      }
      const { data } = await api.get<TipoParticipanteResponse>(
        `/v1/AttendantRole/GetAllByCustomerId?${queryParams.toString()}`,
      );
      return {
        status: true,
        data: data,
      };
    } catch (error) {
      console.error("Erro ao buscar os tipos de participante:", error);
      throw error;
    }
  },

  createParticipante: async (authToken: string | null, participant: any) => {
    if (!authToken) {
      return {
        status: false,
        message: "Não é possível inativar o registro sem o token correto.",
      };
    }

    try {
      const body = {
        ...participant,
      };
      const { data } = await api.post<any>(`/v1/AttendantRole/add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  editParticipante: async (authToken: string | null, participant: any) => {
    if (!authToken) {
      return {
        status: false,
        message: "Não é possível inativar o registro sem o token correto.",
      };
    }

    try {
      const body = {
        ...participant,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      };
      const { data } = await api.put<any>(`/v1/AttendantRole/update`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  ativarInativarTipoParticipante: async (
    authToken: string | null,
    id: number,
    valueActive: any,
  ) => {
    if (!authToken) {
      return {
        status: false,
        message: "Não é possível inativar o registro sem o token correto.",
      };
    }

    try {
      const body = [
        {
          op: "replace",
          value: !valueActive,
          path: "active",
        },
      ];
      const { data } = await api.patch<any>(
        `/v1/AttendantRole/update?id=${id}`,
        body,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};
